import { render, staticRenderFns } from "./BaseAccordionWallet.vue?vue&type=template&id=0c951000&scoped=true&"
import script from "./BaseAccordionWallet.vue?vue&type=script&lang=js&"
export * from "./BaseAccordionWallet.vue?vue&type=script&lang=js&"
import style0 from "./BaseAccordionWallet.vue?vue&type=style&index=0&id=0c951000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c951000",
  null
  
)

export default component.exports